class CsForm extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('DOMContentLoaded', () => {
      const closestDetails = this.closest('details');
      const successMessage = this.querySelector('.success-msg');

      if (successMessage) {
        closestDetails.classList.add('menu-opening');
      }

      // Add listener to remove success message on closing
      closestDetails.addEventListener('toggle', () => {
        if (!closestDetails.open) {
          successMessage?.remove();
        }
      });

      // Remove success messages from other contact forms on page
      // by default shopify adds success message to all contact form
      // as ID is not differentiating them
      const sentFormId = window.location.hash;

      if (sentFormId) {
        const forms = document.querySelectorAll(`cs-form form:not(${sentFormId})`);

        forms.forEach((form) => form.querySelector('.success-msg')?.remove());
      }
    });
  }
}

customElements.define('cs-form', CsForm);
